<div class="toast-container">
  <app-toast-notification
    *ngFor="let toast of toasts; trackBy: trackByToastId"

    [message]="toast.message"
    [type]="toast.type"
    [duration]="toast.duration"
    [action]="toast.action"
    [show]="true"
    [dismissable]="toast.dismissable"
    (onClose)="onToastClose(toast.id)"
    [style.margin-bottom.px]="8">
  </app-toast-notification>
</div>
